import gql from "graphql-tag";

export const allRateCardStatusesQuery = gql`
  query RateCardStatuses($installationId: ID!) {
    rateCardsForInstallation(id: $installationId) {
      id
      full
      expired
      bookings
      todayBookings
    }
  }
`;

export const rateCardStatusesQuery = gql`
  query RateCardStatuses($rateCardId: ID!) {
    rateCardStatus(id: $rateCardId) {
      id
      full
      expired
      bookings
      todayBookings
    }
  }
`;
export const allRateCards = gql`
  query allRateCards($installationId: ID!, $isArchived: Boolean!) {
    allRateCards(
      filter: { installationId: $installationId, isArchived: $isArchived }
      orderBy: name_ASC
    ) {
      id
      lineageId
      version

      name
      type
      serviceFeePercent
      defaultOnExit
      defaultPublic

      isPublic
      selfPark
      publicUrl
      ignoreGlobalCapacity
      isValet
      valetRequestFeeAud
      valetFreeRequestsPerDay

      entryAfterTime
      exitBeforeTime
      bookingRateAudPerDay
      weekendSurchargeRate
      weekendDaysOfWeek
      overstayRateAudPerHour
      overstayFlagfallAud
      overstayGraceMinutes

      bookingRateAudPerHour
      chargeOnExpiryAud

      hoursUntilExpiry
      maximum24HourAud

      bookingRateAudPerMonth

      isArchived
      createdAt

      startsAt
      expiresAt
      bookingsLimit
      calculationMode
      lot {
        name
      }

      isVip
      vipEmailRecipient
      defaultVipContactId

      allowFutureDate

      hoursTiers {
        id
        rate
        maxHours
      }
      customHourlyRates
      customDayRates {
        date
        rate
      }

      activeDaysOfWeek
      activeFromMinute
      activeToMinute
      fixedSessionPriceAud
      fixedSessionDurationMinutes
      fixedSessionFullDayFeeAud

      fixedBookingStartDate
      fixedBookingEndDate
      packagePriceAud
    }
  }
`;

export const rateCardById = gql`
  query rateCardById($rateCardId: ID!) {
    rateCard(id: $rateCardId) {
      id
      lineageId
      version

      name
      type
      serviceFeePercent
      defaultOnExit
      defaultPublic

      isPublic
      selfPark
      publicUrl
      stopPublicBookingWhenLotFull
      lotFullText
      homeText
      homeTitle

      entryAfterTime
      exitBeforeTime
      bookingRateAudPerDay
      bookingRateAudPerMonth
      weekendSurchargeRate
      weekendDaysOfWeek
      overstayRateAudPerHour
      overstayFlagfallAud
      overstayGraceMinutes

      bookingRateAudPerHour
      chargeOnExpiryAud

      hoursUntilExpiry
      maximum24HourAud

      ignoreGlobalCapacity
      isValet
      resetLimit
      guestName
      guestEmail
      guestCompany
      guestDepartment
      guestPhone
      guestRoom
      guestApartmentNumber
      guestReservation
      guestEmployeeCode
      guestPosition
      paymentGate
      multiDates
      paymentStripe
      parklioBayAssignment
      valetPayLater
      valetRequestFeeAud
      valetFreeRequestsPerDay
      includeCarType
      includeCarNotes

      isArchived
      createdBy {
        name
      }
      createdAt

      startsAt
      expiresAt
      bookingsLimit
      capacity
      calculationMode

      rateCardExtras {
        description
        amount
        type
        disclaimer
        image
        dailyLimit
        dateScope
      }

      lot {
        id
        name
      }

      isVip
      vipEmailRecipient
      defaultVipContactId
      allowFutureDate

      hasValetOption
      valetGuestCardLineageId

      hoursTiers {
        id
        rate
        maxHours
      }
      customHourlyRates
      customDayRates {
        date
        rate
      }

      isDynamicPublicUrl
      dynamicPublicUrlPrefix
      dynamicPublicUrlUpdatedAt
      dynamicPublicUrlEmails
      dynamicPublicUrlUpdateHour

      activeDaysOfWeek
      activeFromMinute
      activeToMinute
      fixedSessionPriceAud
      fixedSessionDurationMinutes
      fixedSessionFullDayFeeAud

      fixedBookingStartDate
      fixedBookingEndDate
      packagePriceAud
    }
  }
`;

export const sendPayAtGateEmailMutation = gql`
  mutation PayAtGateEmail($input: PayAtGateEmailInput!) {
    sendPayAtGateEmail(payAtGateEmailInput: $input) {
      name
    }
  }
`;

export const createRateCardExtraMutation = gql`
  mutation createRateCardExtra(
    $rateCardId: ID!
    $description: String!
    $amount: String!
    $disclaimer: String
    $image: String
    $type: RateCardExtraTypeEnum!
  ) {
    createRateCardExtra(
      rateCardExtra: {
        rateCardId: $rateCardId
        description: $description
        amount: $amount
        type: $type
        disclaimer: $disclaimer
        image: $image
      }
    ) {
      id
      description
    }
  }
`;

export const extraImageUploadUrlMutation = gql`
  mutation ExtraImageUploadUrl($brandingKey: String!, $contentType: String!) {
    extraImageUploadUrl(brandingKey: $brandingKey, contentType: $contentType) {
      uploadUrl
      publicUrl
    }
  }
`;

export const createRateCardMutation = gql`
  mutation createRateCard(
    $installationId: ID!
    $lineageId: ID
    $name: String!
    $type: RateCardTypeEnum!
    $defaultOnExit: Boolean!
    $defaultPublic: Boolean!
    $isPublic: Boolean!
    $selfPark: Boolean!
    $includeCarType: Boolean
    $includeCarNotes: Boolean
    $publicUrl: String
    $stopPublicBookingWhenLotFull: Boolean
    $lotFullText: String
    $homeText: String
    $homeTitle: String
    $entryAfterTime: Int!
    $exitBeforeTime: Int!
    $bookingRateAudPerDay: String!
    $bookingRateAudPerMonth: String!
    $overstayRateAudPerHour: String!
    $overstayFlagfallAud: String!
    $overstayGraceMinutes: Int!
    $bookingRateAudPerHour: String!
    $chargeOnExpiryAud: String!
    $maximum24HourAud: String!
    $hoursUntilExpiry: Int!
    $bookingsLimit: Int
    $capacity: Int
    $expiresAt: String
    $startsAt: String
    $ignoreGlobalCapacity: Boolean!
    $isValet: Boolean
    $resetLimit: RateCardResetLimitEnum!
    $guestName: Boolean!
    $guestEmail: Boolean!
    $guestCompany: Boolean!
    $guestDepartment: Boolean!
    $guestPhone: Boolean!
    $guestRoom: Boolean!
    $guestApartmentNumber: Boolean!
    $guestReservation: Boolean!
    $guestEmployeeCode: Boolean!
    $guestPosition: Boolean!
    $paymentGate: Boolean!
    $multiDates: Boolean!
    $paymentStripe: Boolean!
    $parklioBayAssignment: Boolean
    $valetPayLater: Boolean
    $valetRequestFeeAud: String
    $valetFreeRequestsPerDay: Int
    $lotId: ID
    $calculationMode: RateCardCalculationModeEnum!
    $isVip: Boolean!
    $vipEmailRecipient: String
    $defaultVipContactId: ID
    $hasValetOption: Boolean
    $valetGuestCardLineageId: ID
    $allowFutureDate: Boolean!
    $weekendSurchargeRate: String!
    $weekendDaysOfWeek: [Int!]
    $customHourlyRates: [CustomHourlyRate!]
    $customDayRates: [CustomDayRateInput!]
    $isDynamicPublicUrl: Boolean
    $dynamicPublicUrlEmails: [String!]
    $dynamicPublicUrlUpdateHour: Int
    $hoursTiers: [BaseRateCardHoursTierInput!]
    $rateCardExtras: [BaseRateCardExtraInput!]
    $activeDaysOfWeek: [Int!]
    $activeFromMinute: Int
    $activeToMinute: Int
    $fixedSessionPriceAud: String
    $fixedSessionDurationMinutes: Int
    $fixedSessionFullDayFeeAud: String
    $fixedBookingStartDate: String
    $fixedBookingEndDate: String
    $packagePriceAud: String
  ) {
    createRateCard(
      rateCard: {
        installationId: $installationId
        lineageId: $lineageId
        lotId: $lotId
        name: $name
        type: $type
        defaultOnExit: $defaultOnExit
        defaultPublic: $defaultPublic
        isPublic: $isPublic
        includeCarType: $includeCarType
        includeCarNotes: $includeCarNotes
        selfPark: $selfPark
        publicUrl: $publicUrl
        stopPublicBookingWhenLotFull: $stopPublicBookingWhenLotFull
        lotFullText: $lotFullText
        homeText: $homeText
        homeTitle: $homeTitle
        entryAfterTime: $entryAfterTime
        exitBeforeTime: $exitBeforeTime
        bookingRateAudPerDay: $bookingRateAudPerDay
        bookingRateAudPerMonth: $bookingRateAudPerMonth
        overstayRateAudPerHour: $overstayRateAudPerHour
        overstayFlagfallAud: $overstayFlagfallAud
        overstayGraceMinutes: $overstayGraceMinutes
        bookingRateAudPerHour: $bookingRateAudPerHour
        chargeOnExpiryAud: $chargeOnExpiryAud
        maximum24HourAud: $maximum24HourAud
        hoursUntilExpiry: $hoursUntilExpiry
        ignoreGlobalCapacity: $ignoreGlobalCapacity
        isValet: $isValet
        resetLimit: $resetLimit
        guestName: $guestName
        guestEmail: $guestEmail
        guestCompany: $guestCompany
        guestDepartment: $guestDepartment
        guestPhone: $guestPhone
        guestRoom: $guestRoom
        guestApartmentNumber: $guestApartmentNumber
        guestReservation: $guestReservation
        guestEmployeeCode: $guestEmployeeCode
        guestPosition: $guestPosition
        paymentGate: $paymentGate
        multiDates: $multiDates
        paymentStripe: $paymentStripe
        parklioBayAssignment: $parklioBayAssignment
        valetPayLater: $valetPayLater
        valetRequestFeeAud: $valetRequestFeeAud
        valetFreeRequestsPerDay: $valetFreeRequestsPerDay
        bookingsLimit: $bookingsLimit
        capacity: $capacity
        expiresAt: $expiresAt
        startsAt: $startsAt
        calculationMode: $calculationMode
        isVip: $isVip
        vipEmailRecipient: $vipEmailRecipient
        defaultVipContactId: $defaultVipContactId
        hasValetOption: $hasValetOption
        valetGuestCardLineageId: $valetGuestCardLineageId
        allowFutureDate: $allowFutureDate
        weekendSurchargeRate: $weekendSurchargeRate
        weekendDaysOfWeek: $weekendDaysOfWeek
        customHourlyRates: $customHourlyRates
        customDayRates: $customDayRates
        isDynamicPublicUrl: $isDynamicPublicUrl
        dynamicPublicUrlEmails: $dynamicPublicUrlEmails
        dynamicPublicUrlUpdateHour: $dynamicPublicUrlUpdateHour
        hoursTiers: $hoursTiers
        rateCardExtras: $rateCardExtras
        activeDaysOfWeek: $activeDaysOfWeek
        activeFromMinute: $activeFromMinute
        activeToMinute: $activeToMinute
        fixedSessionPriceAud: $fixedSessionPriceAud
        fixedSessionDurationMinutes: $fixedSessionDurationMinutes
        fixedSessionFullDayFeeAud: $fixedSessionFullDayFeeAud
        fixedBookingStartDate: $fixedBookingStartDate
        fixedBookingEndDate: $fixedBookingEndDate
        packagePriceAud: $packagePriceAud
      }
    ) {
      id
      name
    }
  }
`;

export const archiveRateCardMutation = gql`
  mutation archiveRateCard($rateCardId: ID!) {
    updateRateCard(id: $rateCardId) {
      id
    }
  }
`;

export const createHourlyRateMutation = gql`
  mutation createHourlyRate($input: CreateHourlyRatesInput!) {
    createHourlyRate(input: $input) {
      id
    }
  }
`;

export const updateHourlyRateValuesMutation = gql`
  mutation updateHourlyRateValues($input: UpdateHourlyRatesInput!) {
    updateHourlyRateValues(input: $input) {
      facilityId
    }
  }
`;

export const hourlyRateByFacility = gql`
  query hourlyRateByFacility($installationId: ID!) {
    hourlyRateByFacility(installationId: $installationId) {
      facilityId
      rate
      maxDailyCharge
      gracePeriodMinutes
      override
    }
  }
`;

export const isPlateInLot = gql`
  query Facility($id: ID!, $plate: String!) {
    facility(id: $id) {
      isPlateInLot(plate: $plate)
    }
  }
`;

export const updateFeatureFacilityProviderConfigurationMutation = gql`
    mutation updateFeatureFacilityProviderConfiguration(
        $id: ID!
        $configuration: JSON
    ) {
        updateFeatureFacilityProviderConfiguration(
            id: $id
            configuration: $configuration
        ) {
            id
            configuration
        }
    }
`;

export const createRateCardHoursTiersMutation = gql`
  mutation createRateCardHoursTiers(
    $hoursTiers: [RateCardHoursTierInput!]!
  ) {
    createRateCardsHoursTiers(input: $hoursTiers) {
      rateCardId
      rate
      maxHours
    }
  }
`;

export const bookingUiV2EnabledQuery = gql`
  query bookingUiV2Enabled($installationId: ID!) {
    bookingUiV2Enabled(installationId: $installationId)
  }
`;
